// THE ONE CATALOGUE's two places (Nika's decision 7, "one catalogue": /apps +
// an App Store tab; persona audit round 1, ledger AS-3 — tomas pressed "Apps"
// and met a developer studio, elena met three names for one store). The
// workspace's own apps live at /apps, the App Store at /apps/store; the
// shell's /apps page and the App Store both draw this row, so the two read as
// one catalogue with two tabs.
//
// Links between two PAGES — a `nav` with `aria-current="page"` on the place
// shown, not a tablist (a tablist's panels share one page; these do not). The
// row's `current` ('apps' | 'store') names the place it is drawn on. The words
// are the two places' own nav labels — the Apps views card's "Workspace apps"
// and the launcher's "App Store" (`shell` is a boot namespace, so both resolve
// on the first paint) — so the bar, the menu and this row say the same words.
//
// A SHELL component (the shell owns /apps and the `shell.*` words). The App
// Store borrows it by bare key only in catalogue mode, which is in-shell only
// (marketplace `initMarketplaceCatalogueMode`). Its look is the store's
// `MarketplaceSegment`, an eager marketplace component (marketplace
// components/eagerSlice.js), so it resolves on the shell's /apps page before
// any store route folds the marketplace context.

// One place. A real `Link` (Rule 41) with the store's segment look. Inside the
// shell a press opens the place in the shell's pane, as the navbar's Apps does
// (`preferSlot`): neither /apps nor /apps/store is an app-window route, so a
// plain openAppPage left the pane for a full page (live on dev, 2026-10-25).
export const AppsCatalogueTab = {
  extends: ['Link', 'MarketplaceSegment'],
  href: (el, s) => s.href,
  isActive: (el, s) => !!s.current,
  aria: { current: (el, s) => (s.current ? 'page' : null) },
  onClick: (e, el, s) => {
    if (s.current) {
      e.preventDefault()
      return
    }
    if (typeof el.context?.functions?.openAppPage !== 'function') return
    e.preventDefault()
    el.call('openAppPage', s.href, { preferSlot: true })
  }
}

export const AppsCatalogueTabs = {
  tag: 'nav',
  flow: 'x',
  align: 'center',
  gap: 'X',
  padding: 'X',
  alignSelf: 'center',
  // Never squeezed: the row clips its overflow (overflowY hidden), so in a
  // height-bound column — the Apps page scrolls — a shrinkable row collapsed
  // to a sliver and cut its words in half (live on dev, 2026-10-25).
  flexShrink: '0',
  // Radius token clamps to a true stadium shape (the house trick the surface
  // switcher's track uses).
  round: 'radiusPill',
  background: 'overlay',
  minWidth: '0',
  maxWidth: '100%',
  overflowX: 'auto',
  overflowY: 'hidden',
  aria: { label: (el) => el.call('polyglot', 'shell.app.studio') },

  childrenAs: 'state',
  childExtends: 'AppsCatalogueTab',
  children: (el) => [
    {
      key: 'catalogue-apps',
      href: '/apps',
      label: 'shell.viewNav.workspaceApps',
      current: el.current === 'apps'
    },
    {
      key: 'catalogue-store',
      href: '/apps/store',
      label: 'shell.launcher.appStore',
      current: el.current === 'store'
    }
  ]
}
